import styled from "styled-components";
import { Table } from "antd";
import { COLORS } from "Styles/Constants";

export const TableWrapper = styled(Table)`
	tr:nth-child(odd) td {
		/* background-color: #a5a1a16b !important; */
	}

	/*
	 * Long option values used to wrap character by character inside narrow fixed columns, producing
	 * rows several times taller than their neighbours and making a question table impossible to
	 * scan. Breaking on word boundaries keeps rows an even height; break-word is the fallback for a
	 * single token with no spaces in it (a URL, a long chemical name).
	 */
	.ant-table-tbody > tr > td {
		word-break: break-word;
		overflow-wrap: anywhere;
		hyphens: auto;
	}

	/*
	 * Short headers ("Points") were wrapping to three lines - rendering as "Po int s" - because the
	 * column was narrower than the word. A header never needs to wrap: let the column carry the
	 * label on one line and ellipsise only if it truly cannot fit.
	 */
	.ant-table-thead > tr > th {
		white-space: nowrap;
	}

	/* Numbers should never break mid-value the way "1,00" / "0,000" did in the Points column. */
	.ant-table-tbody > tr > td.ant-table-cell-numeric,
	.ant-table-tbody > tr > td[data-numeric="true"] {
		white-space: nowrap;
	}
`;

export const CardWrapper = styled.div`
	background: #fff;
	box-shadow: 0 0 15px #dbdbdb;
	border-radius: 5px;
	padding: ${(props) => props.spacing || "10"}px;

	.ant-table table {
		margin-top: 10px;
	}
`;

export const PageTitleWrapper = styled.h1`
	color: #000;
	font-weight: bold;
	text-align: ${(props) => props.titlePosition};
	width: 100%;
	text-decoration: underline;
`;
export const PageDropDownWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
`;

export const PageSubTitle1Wrapper = styled.h1`
	color: rgb(120, 129, 149);
	font-size: 15px;
`;
export const ActionItemWrapper = styled.span`
	color: #008dff;
	cursor: pointer;
`;

/*  DRAWER CONTENT */
export const DrawerContent = styled.div``;
export const DrawerFooterWrapper = styled.div`
	.ant-btn {
		margin-right: 10px;
		min-width: 100px;
		height: 40px;
	}
`;

export const FirstLevelHeaderWrapper = styled.div`
	align-items: baseline;

	.header-details {
		padding: 0 0 0 10px;
		flex: 1;
		position: relative;

		.page-title {
			font-size: 22px;
			font-weight: 600;

			&.underline {
				text-decoration: underline;
			}

			&.admin-title-position {
				position: absolute;
				left: 50%;
				top: 0;
				transform: translate(-50%, 0);
			}

			&.user-title-position {
				text-align: center;
			}
		}

		.back-btn-title {
			font-size: 14px;
			font-weight: 400;
			color: ${COLORS.GREY_TEXT_LIGHT};
		}

		.page-details {
			gap: 10px;
			margin-top: 35px;

			.text {
				font-size: 14px;
				font-weight: 400;
				color: ${COLORS.GREY_TEXT_LIGHT};
			}
		}
	}
`;

export const SecondLevelHeaderWrapper = styled.div`
	align-items: baseline;

	.header-details {
		padding: 0 0 0 10px;
		flex: 1;
		position: relative;

		.user-img {
			border: 1px dashed ${COLORS.GREY_BORDER};
			margin-top: 20px;
		}

		.page-title {
			font-size: 22px;
			font-weight: 600;
			position: absolute;
			left: 50%;
			top: 0;
			transform: translate(-50%, 0);

			&.underline {
				text-decoration: underline;
			}
		}

		.back-btn-title {
			font-size: 14px;
			font-weight: 400;
			color: ${COLORS.GREY_TEXT_LIGHT};
		}

		.page-details {
			margin-top: 35px;
			gap: 10px;

			.gap {
				gap: 10px;
			}

			.text {
				font-size: 14px;
				font-weight: 400;
				color: ${COLORS.GREY_TEXT_LIGHT};
			}
		}

		.select-field {
			margin-top: 15px;
		}
	}
`;

export const SideDrawerWrapper = styled.div`
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

export const WarningMessage = styled.div`
	color: #ec2c0e;
	margin-top: 15px;
`;

export const SelectContainer = styled.div`
	justify-content: space-between;
	margin-bottom: 8px;
	align-items: end;

	.select-menu {
		width: 200px;
	}
`;

export const DivWrapper = styled.div`
	max-height: 100px;
	display: flex;
	overflow: auto;
	flex-wrap: wrap;
	row-gap: 4px;
`;
